import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthCallback } from "./context/auth";
import { FamilyProvider } from "./context/FamilyContext";
import { Shell } from "./components/Shell";
import Landing from "./pages/Landing";
import Eligibility from "./pages/Eligibility";
import Story from "./pages/Story";
import Film from "./pages/Film";
import Dashboard from "./pages/Dashboard";
import Ask from "./pages/Ask";
import Agreement from "./pages/Agreement";
import { BriefNew, BriefView } from "./pages/Brief";
import Visit from "./pages/Visit";
import { ReportDraft, ReportView } from "./pages/Report";
import HelperHome from "./pages/HelperHome";
import Partner from "./pages/Partner";
import ComingSoon from "./pages/ComingSoon";
import { Join, PublicBrief, HelperLogin, HelperVerify } from "./pages/Public";

function familyRoutes(helperIndex) {
  return (
    <>
      <Route index element={helperIndex ? <HelperHome /> : <Dashboard />} />
      <Route path="ask" element={<Ask />} />
      <Route path="agreement" element={<Agreement />} />
      <Route path="brief" element={<BriefNew />} />
      <Route path="briefs/:bid" element={<BriefView />} />
      <Route path="helper" element={<HelperHome />} />
      <Route path="visit" element={<Visit />} />
      <Route path="report/:vid" element={<ReportDraft />} />
      <Route path="reports/:rid" element={<ReportView />} />
      <Route path="partner" element={<Partner />} />
      {["training", "certificates", "identity", "background", "export"].map((k) => (
        <Route key={k} path={k} element={<ComingSoon kind={k} />} />
      ))}
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/check" element={<Eligibility />} />
      <Route path="/story" element={<Story />} />
      <Route path="/film" element={<Film />} />
      <Route path="/join/:token" element={<Join />} />
      <Route path="/b/:token" element={<PublicBrief />} />
      <Route path="/helper/login" element={<HelperLogin />} />
      <Route path="/helper/verify" element={<HelperVerify />} />
      <Route path="/demo" element={<FamilyProvider mode="demo"><Shell /></FamilyProvider>}>{familyRoutes(false)}</Route>
      <Route path="/app" element={<FamilyProvider mode="app"><Shell /></FamilyProvider>}>{familyRoutes(false)}</Route>
      <Route path="/helper" element={<FamilyProvider mode="helper"><Shell /></FamilyProvider>}>{familyRoutes(true)}</Route>
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{ style: { boxShadow: "none", border: "1.5px solid var(--hf-line)", borderRadius: 12, background: "#fff", color: "var(--hf-ink)", fontFamily: "var(--hf-font-body)" } }}
      />
    </div>
  );
}
